import ExpensesList from '@/components/expenses/ExpensesList'
import ExpensesNew from '@/components/expenses/ExpensesNew'
import ExpensesEdit from '@/components/expenses/ExpensesEdit'
export default [
  {
    path: '/expenses',
    name: 'expenses',
    component: ExpensesList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/expenses/new',
    name: 'expensesNew',
    component: ExpensesNew,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/expenses/:id/edit',
    name: 'expensesEdit',
    component: ExpensesEdit,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/expensesRoutes.js